module.exports = __webpack_public_path__ + "img/19.25809c7c.jpg";